// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SnIs40ISaSqTqZ {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 4px;
  margin: 0 -4px;
  margin-top: 8px;
  margin-bottom: 16px;
}
.hPWASVbIXYzcTo {
  margin-right: 0;
  margin-left: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"palette": `SnIs40ISaSqTqZ`,
	"noHorizontalMargin": `hPWASVbIXYzcTo`
};
export default ___CSS_LOADER_EXPORT___;
